import React, { useEffect, useState, useRef } from 'react';
import { useGLTF, Text, Line, Cone } from '@react-three/drei';
import { useParams } from 'react-router-dom';

function BaseClampModel(props) {
  let para = useParams();
  let [showhandrail, setshowhandrail] = useState(true);

  useEffect(() => {
    if (props.handlaufmat) {
      if (props.handlaufmat == 'none') {
        console.log(props.handlaufmat);
        setshowhandrail(false);
      } else {
        setshowhandrail(true);
      }
    }
  }, [props.handlaufmat]);

  function RenderBaseClamps() {
    let panelwidthi = 100.0000001;
    let panelwidthl = 100.0000001;
    let panelwidthu = 100.0000001;
    if (props.panelwidthi) {
      panelwidthi = props.panelwidthi;
    }
    if (props.panelwidthl) {
      panelwidthl = props.panelwidthl;
    }
    if (props.panelwidthu) {
      panelwidthu = props.panelwidthu;
    }
    let color = '';
    let length2 = parseInt(props.len2 / 10);
    let length1 = parseInt(props.len1 / 10);
    let length3 = parseInt(props.len3 / 10);
    let amount = parseInt(length1) / panelwidthi;
    let amount2 = parseInt(length2) / panelwidthl;
    let amount3 = parseInt(length3) / panelwidthu;

    if (props.colorr) {
      if (props.colorr == 'black') {
        color = '#111';
      }
      if (props.colorr == 'anrtz') {
        color = '#293133';
      }
      if (props.colorr == 'gray') {
        color = '#fff';
      }
      if (props.colorr == 'brano') {
        color = '#D0D5D9';
      }
    }

    amount = parseInt(amount);
    amount2 = parseInt(amount2);
    amount3 = parseInt(amount3);
    amount = amount + 1;
    amount2 = amount2 + 1;
    amount3 = amount3 + 1;

    let height = props.hohe;

    let heightscale = 1;
    let heightposition = 0;
    if (height == 900) {
      heightscale = 0.81;
      heightposition = -10.1;
    }
    if (height == 1000) {
      heightscale = 0.91;
      heightposition = -4.8;
    }

    let singlelength = (length1 / amount).toFixed(3);
    let singlelength2 = (length2 / amount2).toFixed(3);
    let singlelength3 = (length3 / amount3).toFixed(3);

    let ClampadjustI = 25;
    let ClampadjustL = 25;
    let ClampadjustU = 25;

    ClampadjustI = singlelength / 4;
    ClampadjustL = singlelength2 / 4;
    ClampadjustU = singlelength3 / 4;

    if (panelwidthi > 100.001) {
      let onepart = singlelength / 6;
      ClampadjustI = 2 * onepart;
    }
    if (panelwidthl > 100.001) {
      let onepart = singlelength2 / 6;
      ClampadjustL = 2 * onepart;
    }
    if (panelwidthu > 100.001) {
      let onepart = singlelength3 / 6;
      ClampadjustU = 2 * onepart;
    }

    if (props.form == 'i') {
      let pointarr = [];
      for (let i = 0; i < amount; i++) {
        let pushy = [0, 0, (singlelength / 10) * i];
        pointarr.push(pushy);
      }

      return pointarr.map((point) => {
        return (
          <group ref={group} {...props} dispose={null} scale={[0.1, 0.1, 0.1]} position={point}>
            <group position={[0, 59.35 + heightposition, 0]} scale={[1, heightscale, singlelength / 100 - 0.01]}>
              <mesh material={materials['Glass Frosted']} geometry={nodes.Glass_1.geometry} position={[-0.3, 0, 0]} />
              <mesh material={materials['Glass Frosted']} geometry={nodes.Glass_2.geometry} position={[0.3, 0, 0]} />
            </group>
            <group position={[0.15, 2.75, -ClampadjustI]} rotation={[Math.PI / 2, 0, 0]}>
              <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                <mesh
                  material={materials['physi alu bright']}
                  material-color={color}
                  geometry={nodes['640012_Cover'].geometry}
                />
              </group>
              <mesh
                material={materials['physi alu bright']}
                geometry={nodes['640012_Cover'].geometry}
                position={[-0.15, 0, 1.75]}
                rotation={[-Math.PI / 2, Math.PI / 2, 0]}
              />
              <mesh
                material={materials['physi alu']}
                geometry={nodes['640014_Inlay'].geometry}
                position={[-0.15, 0, -4.25]}
                rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
              />
              <mesh
                material={materials['physi alu']}
                geometry={nodes['640015_Inlay'].geometry}
                position={[-0.17, 0, 1.75]}
                rotation={[-Math.PI / 2, Math.PI / 2, 0]}
              />
              <mesh
                material={materials['physi alu']}
                geometry={nodes['640016_Inlay'].geometry}
                position={[-0.14, 0, 1.78]}
                rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
              />
              <mesh
                material={materials['physi alu']}
                geometry={nodes['640017_Inlay'].geometry}
                position={[0.92, 0, -4.55]}
                rotation={[Math.PI / 2, 0, -Math.PI]}
              />
            </group>
            <group position={[0.15, 2.75, ClampadjustI]} rotation={[Math.PI / 2, 0, 0]}>
              <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                <mesh material={materials['physi alu bright']} geometry={nodes['640022_Cover_1'].geometry} />
              </group>
              <mesh
                material={materials['physi alu bright']}
                geometry={nodes['640022_Cover'].geometry}
                position={[-0.15, 0, 1.75]}
                rotation={[-Math.PI / 2, Math.PI / 2, 0]}
              />
              <mesh
                material={materials['physi alu']}
                geometry={nodes['640024_Inlay'].geometry}
                position={[-0.15, 0, -4.25]}
                rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
              />
              <mesh
                material={materials['physi alu']}
                geometry={nodes['640025_Inlay'].geometry}
                position={[-0.17, 0, 1.75]}
                rotation={[-Math.PI / 2, Math.PI / 2, 0]}
              />
              <mesh
                material={materials['physi alu']}
                geometry={nodes['640026_Inlay'].geometry}
                position={[-0.14, 0, 1.78]}
                rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
              />
              <mesh
                material={materials['physi alu']}
                geometry={nodes['640027_Inlay'].geometry}
                position={[0.92, 0, -4.55]}
                rotation={[Math.PI / 2, 0, -Math.PI]}
              />
            </group>

            {singlelength > 100.001 && (
              <group position={[0.15, 2.75, 0]} rotation={[Math.PI / 2, 0, 0]}>
                <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                  <mesh material={materials['physi alu bright']} geometry={nodes['640022_Cover_1'].geometry} />
                </group>
                <mesh
                  material={materials['physi alu bright']}
                  geometry={nodes['640022_Cover'].geometry}
                  position={[-0.15, 0, 1.75]}
                  rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                />
                <mesh
                  material={materials['physi alu']}
                  geometry={nodes['640024_Inlay'].geometry}
                  position={[-0.15, 0, -4.25]}
                  rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                />
                <mesh
                  material={materials['physi alu']}
                  geometry={nodes['640025_Inlay'].geometry}
                  position={[-0.17, 0, 1.75]}
                  rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                />
                <mesh
                  material={materials['physi alu']}
                  geometry={nodes['640026_Inlay'].geometry}
                  position={[-0.14, 0, 1.78]}
                  rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                />
                <mesh
                  material={materials['physi alu']}
                  geometry={nodes['640027_Inlay'].geometry}
                  position={[0.92, 0, -4.55]}
                  rotation={[Math.PI / 2, 0, -Math.PI]}
                />
              </group>
            )}
          </group>
        );
      });
    }

    if (props.form == 'l') {
      let pointarri = [];
      for (let i = 0; i < amount; i++) {
        let pushy = [0, 0, (singlelength / 10) * i + singlelength / 20];
        pointarri.push(pushy);
      }
      let pointarrl = [];
      for (let i = 0; i < amount2; i++) {
        let pushy = [(singlelength2 / 10) * i + singlelength2 / 20, 0, 0];
        pointarrl.push(pushy);
      }

      return (
        <>
          {pointarri.map((point) => {
            return (
              <group ref={group} {...props} dispose={null} scale={[0.1, 0.1, 0.1]} position={point}>
                <group position={[0, 59.35 + heightposition, 0]} scale={[1, heightscale, singlelength / 100 - 0.01]}>
                  <mesh
                    material={materials['Glass Frosted']}
                    geometry={nodes.Glass_1.geometry}
                    position={[-0.3, 0, 0]}
                  />
                  <mesh
                    material={materials['Glass Frosted']}
                    geometry={nodes.Glass_2.geometry}
                    position={[0.3, 0, 0]}
                  />
                </group>
                <group position={[0.15, 2.75, -ClampadjustI]} rotation={[Math.PI / 2, 0, 0]}>
                  <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                    <mesh
                      material={materials['physi alu bright']}
                      material-color={color}
                      geometry={nodes['640012_Cover'].geometry}
                    />
                  </group>
                  <mesh
                    material={materials['physi alu bright']}
                    geometry={nodes['640012_Cover'].geometry}
                    position={[-0.15, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640014_Inlay'].geometry}
                    position={[-0.15, 0, -4.25]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640015_Inlay'].geometry}
                    position={[-0.17, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640016_Inlay'].geometry}
                    position={[-0.14, 0, 1.78]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640017_Inlay'].geometry}
                    position={[0.92, 0, -4.55]}
                    rotation={[Math.PI / 2, 0, -Math.PI]}
                  />
                </group>

                <group position={[0.15, 2.75, ClampadjustI]} rotation={[Math.PI / 2, 0, 0]}>
                  <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                    <mesh material={materials['physi alu bright']} geometry={nodes['640022_Cover_1'].geometry} />
                  </group>
                  <mesh
                    material={materials['physi alu bright']}
                    geometry={nodes['640022_Cover'].geometry}
                    position={[-0.15, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640024_Inlay'].geometry}
                    position={[-0.15, 0, -4.25]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640025_Inlay'].geometry}
                    position={[-0.17, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640026_Inlay'].geometry}
                    position={[-0.14, 0, 1.78]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640027_Inlay'].geometry}
                    position={[0.92, 0, -4.55]}
                    rotation={[Math.PI / 2, 0, -Math.PI]}
                  />
                </group>

                {singlelength > 101 && (
                  <group position={[0.15, 2.75, 0]} rotation={[Math.PI / 2, 0, 0]}>
                    <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                      <mesh material={materials['physi alu bright']} geometry={nodes['640022_Cover_1'].geometry} />
                    </group>
                    <mesh
                      material={materials['physi alu bright']}
                      geometry={nodes['640022_Cover'].geometry}
                      position={[-0.15, 0, 1.75]}
                      rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640024_Inlay'].geometry}
                      position={[-0.15, 0, -4.25]}
                      rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640025_Inlay'].geometry}
                      position={[-0.17, 0, 1.75]}
                      rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640026_Inlay'].geometry}
                      position={[-0.14, 0, 1.78]}
                      rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640027_Inlay'].geometry}
                      position={[0.92, 0, -4.55]}
                      rotation={[Math.PI / 2, 0, -Math.PI]}
                    />
                  </group>
                )}
              </group>
            );
          })}
          {pointarrl.map((point) => {
            return (
              <group
                ref={group}
                {...props}
                dispose={null}
                rotation={[0, 1.57, 0]}
                scale={[0.1, 0.1, 0.1]}
                position={point}
              >
                <group position={[0, 59.35 + heightposition, 0]} scale={[1, heightscale, singlelength2 / 100 - 0.01]}>
                  <mesh
                    material={materials['Glass Frosted']}
                    geometry={nodes.Glass_1.geometry}
                    position={[-0.3, 0, 0]}
                  />
                  <mesh
                    material={materials['Glass Frosted']}
                    geometry={nodes.Glass_2.geometry}
                    position={[0.3, 0, 0]}
                  />
                </group>
                <group position={[0.15, 2.75, -ClampadjustL]} rotation={[Math.PI / 2, 0, 0]}>
                  <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                    <mesh material={materials['physi alu bright']} geometry={nodes['640012_Cover'].geometry} />
                  </group>
                  <mesh
                    material={materials['physi alu bright']}
                    geometry={nodes['640012_Cover'].geometry}
                    position={[-0.15, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640014_Inlay'].geometry}
                    position={[-0.15, 0, -4.25]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640015_Inlay'].geometry}
                    position={[-0.17, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640016_Inlay'].geometry}
                    position={[-0.14, 0, 1.78]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640017_Inlay'].geometry}
                    position={[0.92, 0, -4.55]}
                    rotation={[Math.PI / 2, 0, -Math.PI]}
                  />
                </group>
                <group position={[0.15, 2.75, ClampadjustL]} rotation={[Math.PI / 2, 0, 0]}>
                  <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                    <mesh material={materials['physi alu bright']} geometry={nodes['640022_Cover_1'].geometry} />
                  </group>
                  <mesh
                    material={materials['physi alu bright']}
                    geometry={nodes['640022_Cover'].geometry}
                    position={[-0.15, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640024_Inlay'].geometry}
                    position={[-0.15, 0, -4.25]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640025_Inlay'].geometry}
                    position={[-0.17, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640026_Inlay'].geometry}
                    position={[-0.14, 0, 1.78]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640027_Inlay'].geometry}
                    position={[0.92, 0, -4.55]}
                    rotation={[Math.PI / 2, 0, -Math.PI]}
                  />
                </group>
                {singlelength2 > 101 && (
                  <group position={[0.15, 2.75, 0]} rotation={[Math.PI / 2, 0, 0]}>
                    <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                      <mesh material={materials['physi alu bright']} geometry={nodes['640022_Cover_1'].geometry} />
                    </group>
                    <mesh
                      material={materials['physi alu bright']}
                      geometry={nodes['640022_Cover'].geometry}
                      position={[-0.15, 0, 1.75]}
                      rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640024_Inlay'].geometry}
                      position={[-0.15, 0, -4.25]}
                      rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640025_Inlay'].geometry}
                      position={[-0.17, 0, 1.75]}
                      rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640026_Inlay'].geometry}
                      position={[-0.14, 0, 1.78]}
                      rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640027_Inlay'].geometry}
                      position={[0.92, 0, -4.55]}
                      rotation={[Math.PI / 2, 0, -Math.PI]}
                    />
                  </group>
                )}
              </group>
            );
          })}
        </>
      );
    }

    if (props.form == 'u') {
      let pointarri = [];
      for (let i = 0; i < amount; i++) {
        let pushy = [0, 0, (singlelength / 10) * i + singlelength / 20];
        pointarri.push(pushy);
      }

      let pointarrl = [];
      for (let i = 0; i < amount2; i++) {
        let pushy = [(singlelength2 / 10) * i + singlelength2 / 20, 0, 0];
        pointarrl.push(pushy);
      }

      let pointarru = [];
      for (let i = 0; i < amount3; i++) {
        let pushy = [(singlelength2 / 10) * amount2, 0, (singlelength3 / 10) * i + singlelength3 / 20];
        pointarru.push(pushy);
      }

      return (
        <>
          {pointarri.map((point) => {
            return (
              <group ref={group} {...props} dispose={null} scale={[0.1, 0.1, 0.1]} position={point}>
                <group position={[0, 59.35 + heightposition, 0]} scale={[1, heightscale, singlelength / 100 - 0.01]}>
                  <mesh
                    material={materials['Glass Frosted']}
                    geometry={nodes.Glass_1.geometry}
                    position={[-0.3, 0, 0]}
                  />
                  <mesh
                    material={materials['Glass Frosted']}
                    geometry={nodes.Glass_2.geometry}
                    position={[0.3, 0, 0]}
                  />
                </group>
                <group position={[0.15, 2.75, -ClampadjustI]} rotation={[Math.PI / 2, 0, 0]}>
                  <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                    <mesh
                      material={materials['physi alu bright']}
                      material-color={color}
                      geometry={nodes['640012_Cover'].geometry}
                    />
                  </group>
                  <mesh
                    material={materials['physi alu bright']}
                    geometry={nodes['640012_Cover'].geometry}
                    position={[-0.15, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640014_Inlay'].geometry}
                    position={[-0.15, 0, -4.25]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640015_Inlay'].geometry}
                    position={[-0.17, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640016_Inlay'].geometry}
                    position={[-0.14, 0, 1.78]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640017_Inlay'].geometry}
                    position={[0.92, 0, -4.55]}
                    rotation={[Math.PI / 2, 0, -Math.PI]}
                  />
                </group>
                <group position={[0.15, 2.75, ClampadjustI]} rotation={[Math.PI / 2, 0, 0]}>
                  <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                    <mesh material={materials['physi alu bright']} geometry={nodes['640022_Cover_1'].geometry} />
                  </group>
                  <mesh
                    material={materials['physi alu bright']}
                    geometry={nodes['640022_Cover'].geometry}
                    position={[-0.15, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640024_Inlay'].geometry}
                    position={[-0.15, 0, -4.25]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640025_Inlay'].geometry}
                    position={[-0.17, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640026_Inlay'].geometry}
                    position={[-0.14, 0, 1.78]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640027_Inlay'].geometry}
                    position={[0.92, 0, -4.55]}
                    rotation={[Math.PI / 2, 0, -Math.PI]}
                  />
                </group>
                {singlelength > 100.001 && (
                  <group position={[0.15, 2.75, 0]} rotation={[Math.PI / 2, 0, 0]}>
                    <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                      <mesh material={materials['physi alu bright']} geometry={nodes['640022_Cover_1'].geometry} />
                    </group>
                    <mesh
                      material={materials['physi alu bright']}
                      geometry={nodes['640022_Cover'].geometry}
                      position={[-0.15, 0, 1.75]}
                      rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640024_Inlay'].geometry}
                      position={[-0.15, 0, -4.25]}
                      rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640025_Inlay'].geometry}
                      position={[-0.17, 0, 1.75]}
                      rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640026_Inlay'].geometry}
                      position={[-0.14, 0, 1.78]}
                      rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640027_Inlay'].geometry}
                      position={[0.92, 0, -4.55]}
                      rotation={[Math.PI / 2, 0, -Math.PI]}
                    />
                  </group>
                )}
              </group>
            );
          })}
          {pointarrl.map((point) => {
            return (
              <group
                ref={group}
                {...props}
                dispose={null}
                rotation={[0, 1.57, 0]}
                scale={[0.1, 0.1, 0.1]}
                position={point}
              >
                <group position={[0, 59.35 + heightposition, 0]} scale={[1, heightscale, singlelength2 / 100 - 0.01]}>
                  <mesh
                    material={materials['Glass Frosted']}
                    geometry={nodes.Glass_1.geometry}
                    position={[-0.3, 0, 0]}
                  />
                  <mesh
                    material={materials['Glass Frosted']}
                    geometry={nodes.Glass_2.geometry}
                    position={[0.3, 0, 0]}
                  />
                </group>
                <group position={[0.15, 2.75, -ClampadjustL]} rotation={[Math.PI / 2, 0, 0]}>
                  <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                    <mesh material={materials['physi alu bright']} geometry={nodes['640012_Cover'].geometry} />
                  </group>
                  <mesh
                    material={materials['physi alu bright']}
                    geometry={nodes['640012_Cover'].geometry}
                    position={[-0.15, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640014_Inlay'].geometry}
                    position={[-0.15, 0, -4.25]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640015_Inlay'].geometry}
                    position={[-0.17, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640016_Inlay'].geometry}
                    position={[-0.14, 0, 1.78]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640017_Inlay'].geometry}
                    position={[0.92, 0, -4.55]}
                    rotation={[Math.PI / 2, 0, -Math.PI]}
                  />
                </group>
                <group position={[0.15, 2.75, ClampadjustL]} rotation={[Math.PI / 2, 0, 0]}>
                  <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                    <mesh material={materials['physi alu bright']} geometry={nodes['640022_Cover_1'].geometry} />
                  </group>
                  <mesh
                    material={materials['physi alu bright']}
                    geometry={nodes['640022_Cover'].geometry}
                    position={[-0.15, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640024_Inlay'].geometry}
                    position={[-0.15, 0, -4.25]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640025_Inlay'].geometry}
                    position={[-0.17, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640026_Inlay'].geometry}
                    position={[-0.14, 0, 1.78]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640027_Inlay'].geometry}
                    position={[0.92, 0, -4.55]}
                    rotation={[Math.PI / 2, 0, -Math.PI]}
                  />
                </group>
                {singlelength2 > 100.001 && (
                  <group position={[0.15, 2.75, 0]} rotation={[Math.PI / 2, 0, 0]}>
                    <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                      <mesh material={materials['physi alu bright']} geometry={nodes['640022_Cover_1'].geometry} />
                    </group>
                    <mesh
                      material={materials['physi alu bright']}
                      geometry={nodes['640022_Cover'].geometry}
                      position={[-0.15, 0, 1.75]}
                      rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640024_Inlay'].geometry}
                      position={[-0.15, 0, -4.25]}
                      rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640025_Inlay'].geometry}
                      position={[-0.17, 0, 1.75]}
                      rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640026_Inlay'].geometry}
                      position={[-0.14, 0, 1.78]}
                      rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640027_Inlay'].geometry}
                      position={[0.92, 0, -4.55]}
                      rotation={[Math.PI / 2, 0, -Math.PI]}
                    />
                  </group>
                )}
              </group>
            );
          })}

          {pointarru.map((point) => {
            return (
              <group ref={group} {...props} dispose={null} scale={[0.1, 0.1, 0.1]} position={point}>
                <group position={[0, 59.35 + heightposition, 0]} scale={[1, heightscale, singlelength3 / 100 - 0.01]}>
                  <mesh
                    material={materials['Glass Frosted']}
                    geometry={nodes.Glass_1.geometry}
                    position={[-0.3, 0, 0]}
                  />
                  <mesh
                    material={materials['Glass Frosted']}
                    geometry={nodes.Glass_2.geometry}
                    position={[0.3, 0, 0]}
                  />
                </group>
                <group position={[0.15, 2.75, -ClampadjustU]} rotation={[Math.PI / 2, 0, 0]}>
                  <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                    <mesh material={materials['physi alu bright']} geometry={nodes['640012_Cover'].geometry} />
                  </group>
                  <mesh
                    material={materials['physi alu bright']}
                    geometry={nodes['640012_Cover'].geometry}
                    position={[-0.15, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640014_Inlay'].geometry}
                    position={[-0.15, 0, -4.25]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640015_Inlay'].geometry}
                    position={[-0.17, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640016_Inlay'].geometry}
                    position={[-0.14, 0, 1.78]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640017_Inlay'].geometry}
                    position={[0.92, 0, -4.55]}
                    rotation={[Math.PI / 2, 0, -Math.PI]}
                  />
                </group>
                <group position={[0.15, 2.75, ClampadjustU]} rotation={[Math.PI / 2, 0, 0]}>
                  <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                    <mesh material={materials['physi alu bright']} geometry={nodes['640022_Cover_1'].geometry} />
                  </group>
                  <mesh
                    material={materials['physi alu bright']}
                    geometry={nodes['640022_Cover'].geometry}
                    position={[-0.15, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640024_Inlay'].geometry}
                    position={[-0.15, 0, -4.25]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640025_Inlay'].geometry}
                    position={[-0.17, 0, 1.75]}
                    rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640026_Inlay'].geometry}
                    position={[-0.14, 0, 1.78]}
                    rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                  />
                  <mesh
                    material={materials['physi alu']}
                    geometry={nodes['640027_Inlay'].geometry}
                    position={[0.92, 0, -4.55]}
                    rotation={[Math.PI / 2, 0, -Math.PI]}
                  />
                </group>
                {singlelength3 > 100.001 && (
                  <group position={[0.15, 2.75, 0]} rotation={[Math.PI / 2, 0, 0]}>
                    <group position={[-0.15, 0, 1.75]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
                      <mesh material={materials['physi alu bright']} geometry={nodes['640022_Cover_1'].geometry} />
                    </group>
                    <mesh
                      material={materials['physi alu bright']}
                      geometry={nodes['640022_Cover'].geometry}
                      position={[-0.15, 0, 1.75]}
                      rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640024_Inlay'].geometry}
                      position={[-0.15, 0, -4.25]}
                      rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640025_Inlay'].geometry}
                      position={[-0.17, 0, 1.75]}
                      rotation={[-Math.PI / 2, Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640026_Inlay'].geometry}
                      position={[-0.14, 0, 1.78]}
                      rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                    />
                    <mesh
                      material={materials['physi alu']}
                      geometry={nodes['640027_Inlay'].geometry}
                      position={[0.92, 0, -4.55]}
                      rotation={[Math.PI / 2, 0, -Math.PI]}
                    />
                  </group>
                )}
              </group>
            );
          })}
        </>
      );
    }
  }

  function returnFloor() {
    //console.log(parseInt(parseInt(props.len1/10)/props.panelwidthi))
    let floorcolor = props.untergrund == 'holz' ? '#452509' : props.untergrund == 'metall' ? '#71797E' : '#D5CFCF';
    let singlelength1 = (props.len1 / (parseInt(parseInt(props.len1 / 10) / props.panelwidthi) + 1)).toFixed(3);
    let Iadjust = 0.005 * singlelength1;

    let height = props.hohe;
    let heightscale = 1;
    let measureheightadjust = 0.75;
    if (height == 900) {
      heightscale = 0.81;
      measureheightadjust = 2.75;
    }
    if (height == 1000) {
      heightscale = 0.91;
      measureheightadjust = 1.75;
    }
    let heightrail = 10 * heightscale + 1;

    let textscale = [1, 1, 1];

    if (props.len1 > 4500 || props.len2 > 4500 || props.len3 > 4500) {
      textscale = [1.2, 1.2, 1.2];
    }
    if (props.len1 > 7000 || props.len2 > 7000 || props.len3 > 7000) {
      textscale = [1.5, 1.5, 1.5];
    }
    if (props.len1 > 13000 || props.len2 > 13000 || props.len3 > 13000) {
      textscale = [2, 2, 2];
    }
    if (props.len1 > 15500 || props.len2 > 15500 || props.len3 > 15500) {
      textscale = [3, 3, 3];
    }

    //console.log(singlelength1)
    if (props.form == 'i') {
      return (
        <>
          <mesh position={[1, -1 + 0.1, props.len1 / 200 - Iadjust]}>
            <boxGeometry args={[3, 2, props.len1 / 100]} />
            <meshStandardMaterial color={floorcolor} material={materials['physi alu']} />
          </mesh>
          <mesh position={[0, heightrail, props.len1 / 200 - Iadjust]} visible={showhandrail}>
            <boxGeometry args={[0.2, 0.2, props.len1 / 100]} />
            <meshStandardMaterial color={'#C0C0C0'} />
          </mesh>

          {/*MEASURES*/}

          <Text
            color={'black'}
            position={[0, 15 - measureheightadjust, props.len1 / 200 - Iadjust]}
            rotation-y={props.polarcoord}
            scale={textscale}
          >
            A :{' '}
            {para.count != ('en-us' || 'es-us') ? props.len1 + ' mm' : parseFloat(props.len1 / 25.4).toFixed(2) + ' "'}
          </Text>
          <Line
            points={[
              [0, 14 - measureheightadjust, -Iadjust],
              [0, 14 - measureheightadjust, props.len1 / 100 - Iadjust],
            ]}
            dashed={false}
          />
          <Cone
            position={[0, 14 - measureheightadjust, props.len1 / 100 - Iadjust - 0.175]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-y={-Math.PI / 2}
            rotation-z={-Math.PI / 2}
          />
          <Cone
            position={[0, 14 - measureheightadjust, -Iadjust + 0.175]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-z={Math.PI / 2}
            rotation-y={-Math.PI / 2}
          />

          <Line
            points={[
              [0, 14.5 - measureheightadjust, props.len1 / 100 - Iadjust],
              [0, 13 - measureheightadjust, props.len1 / 100 - Iadjust],
            ]}
            dashed={false}
          />
          <Line
            points={[
              [0, 14.5 - measureheightadjust, 0 - Iadjust],
              [0, 13 - measureheightadjust, 0 - Iadjust],
            ]}
            dashed={false}
          />

          <Line
            points={[
              [0, 11.9 - measureheightadjust, props.len1 / 100 - Iadjust + 0.8],
              [0, 11.9 - measureheightadjust, props.len1 / 100 - Iadjust + 2.2],
            ]}
            dashed={false}
          />
          <Text
            color={'black'}
            position={[0, 7 - measureheightadjust, props.len1 / 100 - Iadjust + 3.9]}
            rotation-y={props.polarcoord}
            scale={textscale}
          >
            {para.count != 'en-us' && para.count != 'es-us' && props.hohe + ' mm'}
            {(para.count == 'en-us' || para.count == 'es-us') && props.hohe == 900
              ? '36"'
              : (para.count == 'en-us' || para.count == 'es-us') && props.hohe == 1000
                ? '42"'
                : (para.count == 'en-us' || para.count == 'es-us') && props.hohe == 1100
                  ? '48"'
                  : ''}
          </Text>
          <Line
            points={[
              [0, 11.9 - measureheightadjust, props.len1 / 100 - Iadjust + 1.7],
              [0, 0, props.len1 / 100 - Iadjust + 1.7],
            ]}
            dashed={false}
          />
          <Line
            points={[
              [0, 0, props.len1 / 100 - Iadjust + 0.8],
              [0, 0, props.len1 / 100 - Iadjust + 2.2],
            ]}
            dashed={false}
          />
          <Cone
            position={[0, 0 + 0.175, props.len1 / 100 + 1.7 - Iadjust]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-x={Math.PI}
          />
          <Cone
            position={[0, 11.9 - measureheightadjust - 0.175, props.len1 / 100 + 1.7 - Iadjust]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-y={Math.PI / 2}
          />
        </>
      );
    }
    if (props.form == 'l') {
      return (
        <>
          <mesh position={[1, -1 + 0.1, props.len1 / 200]}>
            <boxGeometry args={[3, 2, props.len1 / 100]} />
            <meshStandardMaterial color={floorcolor} material={materials['physi alu']} />
          </mesh>

          {/*RAIL*/}
          <mesh position={[0, heightrail, props.len1 / 200]} visible={showhandrail}>
            <boxGeometry args={[0.2, 0.2, props.len1 / 100]} />
            <meshStandardMaterial color={'#C0C0C0'} />
          </mesh>

          <mesh position={[props.len2 / 200, -1 + 0.1, 1]}>
            <boxGeometry args={[props.len2 / 100, 2, 3]} />
            <meshStandardMaterial color={floorcolor} material={materials['physi alu']} />
          </mesh>

          <mesh position={[props.len2 / 200, heightrail, 0]} visible={showhandrail}>
            <boxGeometry args={[props.len2 / 100, 0.2, 0.2]} />
            <meshStandardMaterial color={'#C0C0C0'} />
          </mesh>

          <mesh position={[0, -1 + 0.1, 1]}>
            <boxGeometry args={[1, 2, 3]} />
            <meshStandardMaterial color={floorcolor} material={materials['physi alu']} />
          </mesh>

          {/*MEASURES*/}

          <Text
            color={'black'}
            position={[0, 15 - measureheightadjust, props.len1 / 200]}
            rotation-y={props.polarcoord}
            scale={textscale}
          >
            A :{' '}
            {para.count != ('en-us' || 'es-us') ? props.len1 + ' mm' : parseFloat(props.len1 / 25.4).toFixed(2) + ' "'}
          </Text>
          <Line
            points={[
              [0, 14 - measureheightadjust, 0],
              [0, 14 - measureheightadjust, props.len1 / 100],
            ]}
            dashed={false}
          />
          <Cone
            position={[0, 14 - measureheightadjust, props.len1 / 100 - 0.175]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-y={-Math.PI / 2}
            rotation-z={-Math.PI / 2}
          />
          <Cone
            position={[0, 14 - measureheightadjust, 0.175]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-z={Math.PI / 2}
            rotation-y={-Math.PI / 2}
          />

          <Text
            color={'black'}
            position={[props.len2 / 200, 15 - measureheightadjust, 0]}
            rotation-y={props.polarcoord}
            scale={textscale}
          >
            B :{' '}
            {para.count != ('en-us' || 'es-us') ? props.len2 + ' mm' : parseFloat(props.len2 / 25.4).toFixed(2) + ' "'}
          </Text>
          <Line
            points={[
              [0, 14 - measureheightadjust, 0],
              [props.len2 / 100, 14 - measureheightadjust, 0],
            ]}
            dashed={false}
          />
          <Cone
            position={[props.len2 / 100 - 0.175, 14 - measureheightadjust, 0]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-x={Math.PI / 2}
            rotation-z={-Math.PI / 2}
          />
          <Cone
            position={[0.175, 14 - measureheightadjust, 0]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-x={Math.PI / 2}
            rotation-z={Math.PI / 2}
          />

          <Line
            points={[
              [0, 14.5 - measureheightadjust, props.len1 / 100],
              [0, 13 - measureheightadjust, props.len1 / 100],
            ]}
            dashed={false}
          />
          <Line
            points={[
              [0, 14.5 - measureheightadjust, 0],
              [0, 13 - measureheightadjust, 0],
            ]}
            dashed={false}
          />
          <Line
            points={[
              [props.len2 / 100, 14.5 - measureheightadjust, 0],
              [props.len2 / 100, 13 - measureheightadjust, 0],
            ]}
            dashed={false}
          />

          <Line
            points={[
              [0, 11.9 - measureheightadjust, props.len1 / 100 + 0.8],
              [0, 11.9 - measureheightadjust, props.len1 / 100 + 2.2],
            ]}
            dashed={false}
          />
          <Text
            color={'black'}
            position={[0, 7 - measureheightadjust, props.len1 / 100 + 3.9]}
            rotation-y={props.polarcoord}
            scale={[1, 1, 1]}
          >
            {para.count != 'en-us' && para.count != 'es-us' && props.hohe + ' mm'}
            {(para.count == 'en-us' || para.count == 'es-us') && props.hohe == 900
              ? '36"'
              : (para.count == 'en-us' || para.count == 'es-us') && props.hohe == 1000
                ? '42"'
                : (para.count == 'en-us' || para.count == 'es-us') && props.hohe == 1100
                  ? '48"'
                  : ''}{' '}
          </Text>
          <Line
            points={[
              [0, 11.9 - measureheightadjust, props.len1 / 100 + 1.7],
              [0, 0, props.len1 / 100 + 1.7],
            ]}
            dashed={false}
          />
          <Line
            points={[
              [0, 0, props.len1 / 100 + 0.8],
              [0, 0, props.len1 / 100 + 2.2],
            ]}
            dashed={false}
          />
          <Cone
            position={[0, 0 + 0.175, props.len1 / 100 + 1.7]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-x={Math.PI}
          />
          <Cone
            position={[0, 11.9 - measureheightadjust - 0.175, props.len1 / 100 + 1.7]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-y={Math.PI / 2}
          />
        </>
      );
    }
    if (props.form == 'u') {
      return (
        <>
          <mesh position={[1, -1 + 0.1, props.len1 / 200]}>
            <boxGeometry args={[3, 2, props.len1 / 100]} />
            <meshStandardMaterial color={floorcolor} material={materials['physi alu']} />
          </mesh>

          <mesh position={[0, heightrail, props.len1 / 200]} visible={showhandrail}>
            <boxGeometry args={[0.2, 0.2, props.len1 / 100]} />
            <meshStandardMaterial color={'#C0C0C0'} />
          </mesh>

          <mesh position={[props.len2 / 200, -1 + 0.1, 1]}>
            <boxGeometry args={[props.len2 / 100, 2, 3]} />
            <meshStandardMaterial color={floorcolor} material={materials['physi alu']} />
          </mesh>

          <mesh position={[props.len2 / 200, heightrail, 0]} visible={showhandrail}>
            <boxGeometry args={[props.len2 / 100, 0.2, 0.2]} />
            <meshStandardMaterial color={'#C0C0C0'} />
          </mesh>

          <mesh position={[0, -1 + 0.1, 1]}>
            <boxGeometry args={[1, 2, 3]} />
            <meshStandardMaterial color={floorcolor} material={materials['physi alu']} />
          </mesh>

          <mesh position={[props.len2 / 100 - 1, -1 + 0.1, props.len3 / 200]}>
            <boxGeometry args={[3, 2, props.len3 / 100]} />
            <meshStandardMaterial color={floorcolor} material={materials['physi alu']} />
          </mesh>

          <mesh position={[props.len2 / 100, heightrail, props.len3 / 200]} visible={showhandrail}>
            <boxGeometry args={[0.2, 0.2, props.len3 / 100]} />
            <meshStandardMaterial color={'C0C0C0'} />
          </mesh>

          <mesh position={[props.len2 / 100 - 1, -1 + 0.1, 0]}>
            <boxGeometry args={[3, 2, 1]} />
            <meshStandardMaterial color={floorcolor} material={materials['physi alu']} />
          </mesh>

          {/*MEASURES*/}

          <Line
            points={[
              [0, 14.5 - measureheightadjust, props.len1 / 100],
              [0, 13 - measureheightadjust, props.len1 / 100],
            ]}
            dashed={false}
          />
          <Line
            points={[
              [0, 14.5 - measureheightadjust, 0],
              [0, 13 - measureheightadjust, 0],
            ]}
            dashed={false}
          />
          <Line
            points={[
              [props.len2 / 100, 14.5 - measureheightadjust, 0],
              [props.len2 / 100, 13 - measureheightadjust, 0],
            ]}
            dashed={false}
          />
          <Line
            points={[
              [props.len2 / 100, 14.5 - measureheightadjust, props.len3 / 100],
              [props.len2 / 100, 13 - measureheightadjust, props.len3 / 100],
            ]}
            dashed={false}
          />

          <Text
            color={'black'}
            position={[0, 15 - measureheightadjust, props.len1 / 200]}
            rotation-y={props.polarcoord}
            scale={textscale}
          >
            A :{' '}
            {para.count != ('en-us' || 'es-us') ? props.len1 + ' mm' : parseFloat(props.len1 / 25.4).toFixed(2) + ' "'}
          </Text>
          <Line
            points={[
              [0, 14 - measureheightadjust, 0],
              [0, 14 - measureheightadjust, props.len1 / 100],
            ]}
            dashed={false}
          />
          <Cone
            position={[0, 14 - measureheightadjust, props.len1 / 100 - 0.175]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-y={-Math.PI / 2}
            rotation-z={-Math.PI / 2}
          />
          <Cone
            position={[0, 14 - measureheightadjust, 0.175]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-z={Math.PI / 2}
            rotation-y={-Math.PI / 2}
          />

          <Text
            color={'black'}
            position={[props.len2 / 200, 15 - measureheightadjust, 0]}
            rotation-y={props.polarcoord}
            scale={textscale}
          >
            B :{' '}
            {para.count != ('en-us' || 'es-us') ? props.len2 + ' mm' : parseFloat(props.len2 / 25.4).toFixed(2) + ' "'}
          </Text>
          <Line
            points={[
              [0, 14 - measureheightadjust, 0],
              [props.len2 / 100, 14 - measureheightadjust, 0],
            ]}
            dashed={false}
          />
          <Cone
            position={[props.len2 / 100 - 0.175, 14 - measureheightadjust, 0]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-x={Math.PI / 2}
            rotation-z={-Math.PI / 2}
          />
          <Cone
            position={[0.175, 14 - measureheightadjust, 0]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-x={Math.PI / 2}
            rotation-z={Math.PI / 2}
          />

          <Text
            color={'black'}
            position={[props.len2 / 100, 15 - measureheightadjust, props.len3 / 200]}
            rotation-y={props.polarcoord}
            scale={textscale}
          >
            C :{' '}
            {para.count != ('en-us' || 'es-us') ? props.len3 + ' mm' : parseFloat(props.len3 / 25.4).toFixed(2) + ' "'}
          </Text>
          <Line
            points={[
              [props.len2 / 100, 14 - measureheightadjust, 0],
              [props.len2 / 100, 14 - measureheightadjust, props.len3 / 100],
            ]}
            dashed={false}
          />
          <Cone
            position={[props.len2 / 100, 14 - measureheightadjust, props.len3 / 100 - 0.175]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-y={-Math.PI / 2}
            rotation-z={-Math.PI / 2}
          />
          <Cone
            position={[props.len2 / 100, 14 - measureheightadjust, 0.175]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-z={Math.PI / 2}
            rotation-y={-Math.PI / 2}
          />

          <Line
            points={[
              [0, 11.9 - measureheightadjust, props.len1 / 100 + 0.8],
              [0, 11.9 - measureheightadjust, props.len1 / 100 + 2.2],
            ]}
            dashed={false}
          />
          <Text
            color={'black'}
            position={[0, 7 - measureheightadjust, props.len1 / 100 + 3.9]}
            rotation-y={props.polarcoord}
            scale={textscale}
          >
            {' '}
            {para.count != 'en-us' && para.count != 'es-us' && props.hohe + ' mm'}
            {(para.count == 'en-us' || para.count == 'es-us') && props.hohe == 900
              ? '36"'
              : (para.count == 'en-us' || para.count == 'es-us') && props.hohe == 1000
                ? '42"'
                : (para.count == 'en-us' || para.count == 'es-us') && props.hohe == 1100
                  ? '48"'
                  : ''}
          </Text>
          <Line
            points={[
              [0, 11.9 - measureheightadjust, props.len1 / 100 + 1.7],
              [0, 0, props.len1 / 100 + 1.7],
            ]}
            dashed={false}
          />
          <Line
            points={[
              [0, 0, props.len1 / 100 + 0.8],
              [0, 0, props.len1 / 100 + 2.2],
            ]}
            dashed={false}
          />

          <Cone
            position={[0, 0 + 0.175, props.len1 / 100 + 1.7]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-x={Math.PI}
          />
          <Cone
            position={[0, 11.9 - measureheightadjust - 0.175, props.len1 / 100 + 1.7]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-y={Math.PI / 2}
          />
        </>
      );
    }
  }

  const group = useRef();
  const { nodes, materials } = useGLTF('/EasyGlassMod6400.gltf');

  return (
    <>
      {RenderBaseClamps()}
      {returnFloor()}
    </>
  );
}

export default BaseClampModel;
